import { createFileRoute, redirect } from '@tanstack/react-router';

// The player became the Rebalance screen and moved to /rebalance. This keeps
// any old links (saved sessions, shared URLs) resolving.
export const Route = createFileRoute('/_app/session/play')({
  beforeLoad: () => {
    throw redirect({ to: '/rebalance' });
  },
});
